import createAxios from "./axiosHttp";

function getAccount() {
  const axios = createAxios();
  const urlPath = "ttmm/account";
  return axios.get(urlPath);
}

function updateAccount(body) {
  const axios = createAxios();
  const urlPath = "ttmm/account";
  return axios.put(urlPath, body);
}

export const accountService = {
  getAccount,
  updateAccount,
};
